export default __webpack_public_path__ + "493497acbd0b2f2cd9c73b28723d41d8.jpg";